import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";
import { Localvalue } from "../../nametitle/localValue";


// Créer un compte 
export const CreateMember = (name, coverPicture, email, telephone, password) => {
  var data = JSON.stringify({
    "name": name,
    "coverPicture": coverPicture,
    "email": email,
    "telephone": telephone,
    "password": password,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/members/`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      alert("Bienvenue vous faire parti des membre")
      //////////console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //////////console.log(error);
    });
}

// Mise ajour du compte 
export const UpdateMember = (id, name, coverPicture, email, code, telephone) => {
  var data = JSON.stringify({
    "name": name,
    "coverPicture": coverPicture,
    "email": email,
    "code": code,
    "telephone": telephone,
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/members/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };

  axios(config)
    .then(function (response) {
      //////////console.log(JSON.stringify(response.data));
      sessionStorage.setItem(Localvalue.nameMemberLogin,response.data.data.name)
      sessionStorage.setItem(Localvalue.idMemberLogin,response.data.data._id)
      sessionStorage.setItem(Localvalue.accessMemberLogin,response.data.data.key)
      sessionStorage.setItem(Localvalue.coverPictureMemberLogin,response.data.data.coverPicture);
    })
    .catch(function (error) {
      //////////console.log(error);
    });

}





// **************************************************************   Mise à jour du mot de passe
export const UpdatePasswordMember = (password, redirect) => {
  var data = JSON.stringify({
    "password": password,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/members/`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //////////console.log(JSON.stringify(response.data));
      redirect(`/${AllRoutes.admin}/${AllRoutes.userlist}`);
    })
    .catch(function (error) {
      //////////console.log(error);
    });
}




// ************************************************ Bloquer acces au compte 
export const StopMember = (id) => {
  var data = JSON.stringify({
    "access": Boolean(false),
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/members/hide/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //////////console.log(JSON.stringify(response.data));
      window.location.reload()
    })
    .catch(function (error) {
      //////////console.log(error);
    });
}




// ********************************************* Débloquer un compte
export const AccessMember = (id) => {
  var data = JSON.stringify({
    "access": Boolean(true),
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/members/show/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //////////console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //////////console.log(error);
    });
}


// Recupérer tout compte des membres
export const LoadAllMember = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/members/get/all`, {
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    }})
    .then(function (response) {
      //////////console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      //////////console.log(error);
    });
}
